export default function Rust_Certificate() {
  return (
    <div>
      <h1>Rust_Certificate Component</h1>
      <p>This is the Rust_Certificate page.</p>
    </div>
  );
}
